import React from 'react';
import { STATUS_COLORS, STATUS_LABELS } from '../config/appConfig';
import { MonitorStatus } from '../types';

interface Props {
  status: MonitorStatus;
  size?: 'sm' | 'md';
}

const StatusPill: React.FC<Props> = ({ status, size = 'md' }) => {
  const color = STATUS_COLORS[status] || '#6B7280';
  const label = STATUS_LABELS[status] || status;
  const padding = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${padding}`}
      style={{ backgroundColor: `${color}1A`, color }}
    >
      <span
        className={`inline-block w-2 h-2 rounded-full ${status === 'down' ? 'pulse-dot' : ''}`}
        style={{ backgroundColor: color }}
      />
      {label}
    </span>
  );
};

export default StatusPill;
